import Vue from 'vue';
import Vuex from 'vuex';
import carousel from './modules/carousel';
import realisations from './modules/realisations';
import offerIcons from './modules/offerIcons';
import gridGallery from './modules/gridGallery';
import szkloCategories from './modules/szkloCategories';
import category from './modules/category';
import login from './modules/auth_required/login';
import gallery from './modules/auth_required/gallery';
import offer from './modules/auth_required/offer';
import textsAdmin from './modules/auth_required/texts_admin';
import texts from './modules/texts';
import compress from './modules/auth_required/compress';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    firstVisit: true
  },
  mutations: {
    visitState(state){
      state.firstVisit = false;
    }
  },
  actions: {
  },
  modules: {
    category,
    carousel,
    realisations,
    offerIcons,
    gridGallery,
    szkloCategories,
    login,
    gallery,
    offer,
    textsAdmin,
    texts,
    compress
  }
})
